import bundleFeature from '../../utils/bundleFeature'

import { PollsContainerComponent } from './components'
import sagas from './sagas'
import actions from './actions'
import reducer from './reducer'
import selectors from './selectors'

export default bundleFeature({
  Component: PollsContainerComponent,
  actions,
  sagas,
  reducer,
  selectors,
})
